import React, { Component } from 'react'
import ContentLoader from 'react-content-loader';
import { connect } from 'react-redux'
import BackButton from '../../../../elements/BackButton'
import { changeStudentAttendence, addStudentAttendence } from '../../../../redux/Teacher/student/action'
import moment from 'moment'
import noStudents from '../../../../assets/Images/no-student.png'

export class ViewAttendence extends Component {
    state = {
        loading: false,
        studentAttendances: {},
    }

    getStudentList = () => {
        const { attendence } = this.props;
        if (!attendence) return [];
        if (Array.isArray(attendence)) return attendence;
        if (Array.isArray(attendence.students)) return attendence.students;
        if (attendence.students && typeof attendence.students === 'object' && !Array.isArray(attendence.students)) {
            return Object.values(attendence.students);
        }
        return [];
    }

    componentDidMount() {
        const students = this.getStudentList();
        if (students.length > 0) {
            let initialMap = {};
            students.forEach(student => {
                const status = student.student_attendences && student.student_attendences[0]
                    ? student.student_attendences[0].details
                    : 'FULL';
                initialMap[student.id] = {
                    attId: student.student_attendences && student.student_attendences[0] ? student.student_attendences[0].id : null,
                    status: status
                };
            });
            this.setState({ studentAttendances: initialMap });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.attendence !== this.props.attendence) {
            const students = this.getStudentList();
            if (students.length > 0) {
                let initialMap = {};
                students.forEach(student => {
                    const status = student.student_attendences && student.student_attendences[0]
                        ? student.student_attendences[0].details
                        : 'FULL';
                    initialMap[student.id] = {
                        attId: student.student_attendences && student.student_attendences[0] ? student.student_attendences[0].id : null,
                        status: status
                    };
                });
                this.setState({ studentAttendances: initialMap });
            }
        }
    }

    handleStatusChange = (studentId, attId, newStatus) => {
        const { teacher, attendence } = this.props;
        const token = teacher?.data?.auth_token;

        // Optimistically update local state
        this.setState(prevState => ({
            studentAttendances: {
                ...prevState.studentAttendances,
                [studentId]: {
                    ...prevState.studentAttendances[studentId],
                    status: newStatus
                }
            }
        }));

        this.props.changeStudentAttendence(token, attId, newStatus, studentId, attendence?.date);
    }

    renderStatusBadge = (studentId, attId, currentStatus) => {
        return (
            <select
                value={currentStatus || 'FULL'}
                onChange={(e) => this.handleStatusChange(studentId, attId, e.target.value)}
                style={{
                    backgroundColor:
                        currentStatus === 'FULL' ? '#58B151' :
                        currentStatus === 'ABSENT' ? '#DB3665' :
                        currentStatus === 'MORNING' ? '#51BBD2' :
                        currentStatus === 'AFTERNOON' ? '#E59866' : '#58B151',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '4px 8px',
                    fontSize: '12px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    outline: 'none'
                }}
            >
                <option value="FULL" style={{ backgroundColor: '#fff', color: '#000' }}>Present</option>
                <option value="ABSENT" style={{ backgroundColor: '#fff', color: '#000' }}>Absent</option>
                <option value="MORNING" style={{ backgroundColor: '#fff', color: '#000' }}>Morning</option>
                <option value="AFTERNOON" style={{ backgroundColor: '#fff', color: '#000' }}>Afternoon</option>
            </select>
        );
    }

    render() {
        const { attendence } = this.props;
        const { studentAttendances } = this.state;
        const students = this.getStudentList();
        const dateStr = attendence?.date ? moment(attendence.date).format('DD MMM YYYY') : moment().format('DD MMM YYYY');
        const classVal = (typeof attendence?.class === 'object' ? attendence?.class?.name : attendence?.class) || attendence?.class_name || '';
        const sectionVal = (typeof attendence?.section === 'object' ? attendence?.section?.name : attendence?.section) || attendence?.section_name || '';
        const className = (classVal || sectionVal) ? `${classVal}${sectionVal ? ' - ' + sectionVal : ''}` : 'N/A';

        return (
            <React.Fragment>
                {this.state.loading ? (
                    <ContentLoader viewBox="0 0 320 658" backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
                        <rect x="16" y="31" rx="6" ry="9" width="24" height="24" />
                        <rect x="98" y="31" rx="6" ry="9" width="123" height="24" />
                        <rect x="15" y="83" rx="6" ry="9" width="288" height="32" />
                        <rect x="15" y="129" rx="10" ry="10" width="288" height="450" />
                    </ContentLoader>
                ) : (
                    <React.Fragment>
                        <BackButton title={"View Attendence"} />
                        <div className='px-3 mt-4'>
                            <div className='d-flex justify-content-between mt-2 px-2 teacher-date-class'>
                                <div>
                                    Date: <span style={{ color: '#c24a6b', fontWeight: '600' }}>{dateStr}</span>
                                </div>
                                <div>
                                    Class: <span style={{ color: '#c24a6b', fontWeight: '600' }}>{className}</span>
                                </div>
                            </div>
                            <div className="panel-board px-3 py-3 mt-3">
                                {students.length > 0 ? (
                                    <table className="w-100">
                                        <thead>
                                            <tr className="panel-head px-3">
                                                <th className="panel-head-2 text-center" style={{ width: '25%' }}>
                                                    Roll No.
                                                </th>
                                                <th className="panel-head-1 text-center" style={{ width: '40%' }}>
                                                    Name
                                                </th>
                                                <th className="panel-head-3 text-center" style={{ width: '35%' }}>
                                                    Status
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {students.map((student) => {
                                                const attInfo = studentAttendances[student.id] || {};
                                                const status = attInfo.status || (student.student_attendences && student.student_attendences[0]?.details) || 'FULL';
                                                const attId = attInfo.attId || (student.student_attendences && student.student_attendences[0]?.id);
                                                const studentName = student?.user ? `${student.user.first_name || ''} ${student.user.last_name || ''}`.trim() || student.user.name : 'N/A';

                                                return (
                                                    <tr key={student.id} className="panel-content">
                                                        <td className="text-center py-2">{student.roll_number || student.id}</td>
                                                        <td className="py-2 text-center">{studentName}</td>
                                                        <td className="text-center py-2">
                                                            {this.renderStatusBadge(student.id, attId, status)}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="text-center py-4">
                                        <img src={noStudents} style={{ width: "60%" }} alt="no_students" />
                                        <div className="text-center fw-bold mt-2 text-muted">
                                            No Attendance Data Found
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    teacher: state.teacher.teacher,
    attendence: state.student.attendence,
})

export default connect(mapStateToProps, {
    changeStudentAttendence,
    addStudentAttendence,
})(ViewAttendence)

